import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Contact(){
    return (
        <>
        <Header />
        <h2>Contact Page</h2>
        <Footer />
        </>
    )
}